/**
 * Cookie bar (snippets/cookie-bar.liquid). Shows only when Shopify says this
 * visitor needs to be asked and hasn't answered yet. Every answer goes through
 * Shopify's Customer Privacy API, never our own cookie, so Shopify, Meta,
 * Google and Clarity (layout/theme.liquid) all follow the same decision.
 *
 * While the bar is open: <html class="cookie-open"> and --cookie-bar-h, so the
 * product page's buy bar can sit on top of it instead of being covered.
 */
(() => {
  const bar = document.querySelector('[data-cookie-bar]');
  const panel = document.querySelector('[data-cookie-panel]');
  if (!bar || !panel) return;
  const root = document.documentElement;
  // The EU/EEA, the UK and Switzerland need consent before tracking
  const CONSENT_REGIONS = /^(AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|RO|SK|SI|ES|SE|IS|LI|NO|GB|CH)/;

  const privacy = () => window.Shopify && window.Shopify.customerPrivacy;

  const setHeight = () => root.style.setProperty('--cookie-bar-h', `${bar.offsetHeight}px`);
  const resize = new ResizeObserver(setHeight);

  function open() {
    bar.hidden = false;
    root.classList.add('cookie-open');
    setHeight();
    resize.observe(bar);
    document.dispatchEvent(new CustomEvent('cookiebar:change', { detail: { open: true } }));
  }

  function close() {
    bar.hidden = true;
    root.classList.remove('cookie-open');
    resize.disconnect();
    root.style.removeProperty('--cookie-bar-h');
    document.dispatchEvent(new CustomEvent('cookiebar:change', { detail: { open: false } }));
  }

  function save(consent) {
    const api = privacy();
    close();
    if (panel.open) panel.close();
    if (!api) return;
    api.setTrackingConsent(consent, () => {});
  }

  const all = (on) => ({ analytics: on, marketing: on, preferences: on });

  function openPanel() {
    const api = privacy();
    const now = api ? api.currentVisitorConsent() : {};
    panel.querySelector('#CookieAnalytics').checked = now.analytics === 'yes';
    panel.querySelector('#CookieMarketing').checked = now.marketing === 'yes';
    panel.querySelector('#CookiePreferences').checked = now.preferences === 'yes';
    panel.showModal();
  }

  document.addEventListener('click', (event) => {
    const t = event.target.closest('[data-cookie-accept], [data-cookie-essential], [data-cookie-more], [data-cookie-save], [data-cookie-prefs]');
    if (!t) return;
    if (t.hasAttribute('data-cookie-accept')) save(all(true));
    else if (t.hasAttribute('data-cookie-essential')) save(all(false));
    else if (t.hasAttribute('data-cookie-save')) {
      save({
        analytics: panel.querySelector('#CookieAnalytics').checked,
        marketing: panel.querySelector('#CookieMarketing').checked,
        preferences: panel.querySelector('#CookiePreferences').checked,
      });
    } else {
      event.preventDefault();
      openPanel();
    }
  });

  // Tapping outside the panel closes it without answering; the bar stays
  panel.addEventListener('click', (event) => {
    if (event.target === panel) panel.close();
  });

  function decide() {
    const api = privacy();
    if (!api) return;
    const answered = api.currentVisitorConsent().analytics !== '';
    if (answered) return;
    const region = (api.getRegion && api.getRegion()) || '';
    if (api.shouldShowBanner() || CONSENT_REGIONS.test(region)) open();
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) decide();
    });
  }
})();
